export default {
  title: "Unsaved Changes",
  content: "Are you sure you want to abort the creation of this Work Order?",
}
